<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">分类名称</div>
            <el-input v-model="add_Name" placeholder="请输入分类名称"></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">分类值</div>
            <el-input v-model="add_Value" placeholder="请输入整数值" ></el-input>
          </el-col>
        </el-row>

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">排序</div>
            <el-input v-model="add_sort" placeholder="请输入排序"></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">充值金额</div>
            <el-input v-model="add_addBalance" placeholder="请输入金额"></el-input>
          </el-col>
        </el-row>

      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm">提交</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Add',
  props: [],
  data() {
    return {

      loading: false,

      add_Name:'',
      add_Value:'',
      add_sort:0,
      add_addBalance:0,

    }
  },
  methods: {
    init(){

      this.add_Name = '';
      this.add_Value = '';
      this.add_sort = 0;
      this.add_addBalance = 0;

    },
    closeSelf() {
      this.loading= false
      this.$emit("closeAdd");
    },

    confirm(){

      if(this.add_Name === ''){
        this.$message("输入分类名称");
        return;
      }
      if(this.add_Value === ''){
        this.$message("输入分类值");
        return;
      }
      if(this.add_sort === ''){
        this.$message("输入排序");
        return;
      }
      if(this.add_addBalance === ''){
        this.$message("输入充值金额");
        return;
      }

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ElderlyClass/GovAdd',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          name: this.add_Name,
          sort:this.add_sort,
          addBalance:this.add_addBalance,
          value:this.add_Value,
        }

      }).then( (response)=> {
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeAdd");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


  }
}
</script>

